import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a78b7f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { isExternal as external } from '@/utils/validate'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  icon: {
    type: String,
    required: true
  },
  className: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;


const isExternal = computed(() => external(props.icon))
const styleExternalIcon = computed(() => ({
  mask: `url(${props.icon}) no-repeat 50% 50%`,
  '-webkit-mask': `url(${props.icon})`
}))
const iconName = computed(() => `#icon-${props.icon}`)

return (_ctx: any,_cache: any) => {
  return (_unref(isExternal))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(_unref(styleExternalIcon)),
        class: _normalizeClass(["svg-external-icon svg-icon", __props.className])
      }, null, 6))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        class: _normalizeClass(["svg-icon", __props.className]),
        "aria-hidden": "true"
      }, [
        _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
      ], 2))
}
}

})